import { useQuery } from '@tanstack/react-query';

import API from 'services/api';
import FormSubmitError from 'errors/FormSubmitError';
import DataRoomCategory from '../../types/api/DataRoomCategory';
import { sortBy } from 'lodash';

export const fetchRfpDataRoom = async (rfpId?: number) => {
  if (rfpId === undefined) {
    throw new Error();
  }

  try {
    const { data: categories } = await API.get<DataRoomCategory[]>(`/rfp/${rfpId}/data-room`);

    categories.forEach((category) => {
      category.data_room_category_files = sortBy(category.data_room_category_files, 'priority');
    });

    return sortBy(categories, 'category_number');
  } catch (e) {
    throw new FormSubmitError('An error occurred while sending request to the server. Please try again.');
  }
};

const getQueryKey = (id?: number) => {
  const keys: unknown[] = ['rfp/dataroom'];

  if (id !== undefined) {
    keys.push(id);
  }

  return keys;
};

const useRfp = (id?: number) => useQuery(getQueryKey(id), () => fetchRfpDataRoom(id), { enabled: !!id });

useRfp.getQueryKey = getQueryKey;
useRfp.queries = {
  fetchRfpDataRoom,
} as const;

export default useRfp;
